import {
  SHOW_MESSAGE,
  CLOSE_MESSAGE,
  SET_LOADING
} from "./types";

export const showMessage = message => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const closeMessage = () => {
  return {
    type: CLOSE_MESSAGE
  };
};

export const setLoading = loading => {
  return {
    type: SET_LOADING,
    payload: loading
  };
};
